import { IAuthManager } from "../../../../OW.Remoting/Remoting/Auth/IAuthManager";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { ILoginCredentialsProvider } from "./ILoginCredentialsProvider";
import { NavigationService } from "./NavigationService";
import { VerificationForm } from "./VerificationForm";

export class EmailForm extends VerificationForm {
    constructor(credentialsProvider: ILoginCredentialsProvider, authManager: IAuthManager, navigator: NavigationService, onSuccessfulLogin: () => any) {
        super(credentialsProvider, authManager, navigator, onSuccessfulLogin);

        this._initializeComponents();
    }

    //#region Methods
    protected override _getErrorElement(): HTMLElement {
        return document.getElementById("error-email-div");
    }

    protected override _getSubmitLoginElement(): HTMLInputElement {
        return document.getElementById("send-email-logon") as HTMLInputElement;
    }

    protected override _getChooseAnotherOptionLink(): HTMLElement {
        return document.getElementById("choose-another-option-email-link");
    }

    protected override _getVerificationCode(): string {
        return this._getVerificationCodeInput().value;
    }

    protected override _clearVerificationCodeInput(): void {
        this._getVerificationCodeInput().value = "";
    }

    protected override _focusVerificationCodeInput(): void {
        this._getVerificationCodeInput().focus();
    }

    private _initializeComponents(): void {
        this._loadTextLocalizations();
        this._registerElementToSubmitByEnter(this._getVerificationCodeInput(), this._getSubmitLoginElement());
        this._registerClickEventListenerToElementById("back-to-login-form-from-email-link", (_e) => this._backToLoginForm());
    }

    private _getVerificationCodeInput(): HTMLInputElement {
        return (document.querySelector("#email-code > input") as HTMLInputElement);
    }

    private _loadTextLocalizations(): void {
        Localization.addLocData(this._getSubmitLoginElement(), "GUI-172655"); // Přihlásit
        Localization.addLocData(this._getSendNewCodeElement(), "GUI-689094"); // Zaslat nový e-mail kód
        Localization.addLocData(document.getElementById("new-email-code-has-been-sent"), "GUI-690326"); // Byl vám zaslán nový kód
        Localization.addLocData(document.getElementById("email-code-label"), "GUI-689092"); // Kód z e-mailové zprávy
        Localization.addLocData(document.getElementById("back-to-login-form-from-email-link"), "GUI-689090"); // ZPĚT NA PŘIHLAŠOVACÍ ÚDAJE
        Localization.addLocData(document.getElementById("email-form__header"), "GUI-689091"); // Dvoufázové ověření
    }

    private _getSendNewCodeElement(): HTMLElement {
        return document.getElementById("send-new-email-code-link") as HTMLElement;
    }
    //#endregion Methods
}
